import { yupResolver } from "@hookform/resolvers/yup";
import { filter } from "lodash";
import { FunctionComponent, useEffect, useMemo } from "react";
import {
  Controller,
  ControllerRenderProps,
  FieldError,
  useFieldArray,
  useForm,
} from "react-hook-form";
import { mixed, object } from "yup";
import { ErrorText } from "../../../../../../components/billing";
import {
  DangerButton,
  PrimaryButton,
} from "../../../../../../components/button";
import { Icon } from "../../../../../../components/icons";
import { Flex } from "../../../../../../components/layout";
import { Field } from "../../../../../../store/launch-configurations/models/internal/field";
import { isDefined } from "../../../../../../utils/utils";
import MultiTextField from "../../../common/multi-lingual-text";
interface IDropDownCustomFieldProps {
  field: ControllerRenderProps<Field.Field<string>, "typeDetails">;
  error: FieldError | undefined;
}

const DropDownCustomField: FunctionComponent<IDropDownCustomFieldProps> = ({
  error,
  field,
}) => {
  const { control, watch } = useForm<{ fields: Array<Record<string, string>> }>(
    {
      resolver: useMemo(
        () =>
          yupResolver(
            object().shape({
              availableOptions: mixed(), // TODO
            })
          ),
        []
      ),
    }
  );

  useEffect(() => {
    const sub = watch((data) => {
      const val: Record<string, Array<string>> = {};

      filter<
        { [x: string]: string | undefined } | undefined,
        { [x: string]: string | undefined }
      >(data.fields || [], isDefined).forEach((f) => {
        Object.keys(f).forEach((lang) => {
          if (val[lang] === undefined) {
            val[lang] = [f[lang] as string];
          } else {
            val[lang].push(f[lang] as string);
          }
        });
      });
      field.onChange(val);
    });
    return () => sub.unsubscribe();
  }, [watch, field.onChange]);

  const fields = useFieldArray({
    control,
    name: "fields",
  });

  return (
    <div>
      {fields.fields.map(({ id }, index) => (
        <Flex>
          <Controller
            key={id}
            control={control}
            name={`fields.${index}`}
            defaultValue={{}}
            render={({ field }) => <MultiTextField {...field} />}
          />
          <DangerButton onClick={() => fields.remove(index)}>
            <Icon type="trash" />
          </DangerButton>
        </Flex>
      ))}

      {error ? <ErrorText>{error.message}</ErrorText> : null}
      <PrimaryButton onClick={() => fields.append({})}>
        Add Option
      </PrimaryButton>
    </div>
  );
};

export default DropDownCustomField;
